import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";

export default function AllNews() {
  const [articles, setArticles] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  const contentRefs = useRef({});
  const articleRefs = useRef({});
  const location = useLocation();

  useEffect(() => {
    fetch("/data/articles_all.json")
      .then((res) => res.json())
      .then((data) => setArticles(data.reverse()));
  }, []);

  // Скролл и подсветка по hash
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = articleRefs.current[id];
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          el.classList.add("highlight");

          setTimeout(() => {
            el.classList.add("fade-out");
            setTimeout(() => {
              el.classList.remove("highlight", "fade-out");
            }, 500);
          }, 500);
        }, 150);
      }
    }
  }, [location, articles]);

  const toggleArticle = (id) => {
    const el = contentRefs.current[id];
    if (!el) return;

    if (expandedId === id) {
      const fullHeight = el.scrollHeight;
      el.style.height = `${fullHeight}px`;
      requestAnimationFrame(() => {
        el.style.transition = "height 1.5s ease";
        el.style.height = "0px";
      });
      setTimeout(() => {
        el.style.transition = "";
        setExpandedId(null);
      }, 1500);
    } else {
      setExpandedId(id);
      requestAnimationFrame(() => {
        const fullHeight = el.scrollHeight;
        el.style.height = "0px";
        requestAnimationFrame(() => {
          el.style.transition = "height 1.5s ease";
          el.style.height = `${fullHeight}px`;
        });
      });
    }
  };

  return (
    <section className="allnews">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title development__title">
        Новости
      </h1>

      <div className="allnews__news">
        {articles.map((article) => {
          const isExpanded = expandedId === article.id;
          const paragraphs = article.content_text.split("\n\n");
          const preview = paragraphs[0];
          const restText = paragraphs.slice(1);
          let dashCounter = 0;
          const url = article.url;

          return (
            <div
              key={article.id}
              ref={(el) => (articleRefs.current[article.id] = el)}
              id={article.id}
              className="allnews__blank"
            >
              <p className="allnews__date">{article.date}</p>
              <div className="week__images">
                {Array.isArray(article.localImg) ? (
                  article.localImg.map((img, index) => (
                    <img
                      key={index}
                      className="allnews__img"
                      src={img}
                      alt={`${article.title}-${index}`}
                    />
                  ))
                ) : (
                  <img
                    className="allnews__img"
                    src={article.localImg}
                    alt={article.title}
                  />
                )}
              </div>

              <h4 className="allnews__title">{article.title}</h4>

              <p className="allnews__text">{preview}</p>

              {/* 🔹 Ссылка на видео (если есть VK) */}
              {url && url.includes("vk.com") && (
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contacts__table-tel"
                >
                  Смотреть видео
                </a>
              )}

              {/* 🔹 Остальной текст новости (с анимацией) */}
              <div
                className="allnews__text-all"
                ref={(el) => (contentRefs.current[article.id] = el)}
                style={{
                  height: isExpanded
                    ? `${contentRefs.current[article.id]?.scrollHeight}px`
                    : "0px",
                  overflow: "hidden",
                }}
              >
                {restText.map((p, idx) => {
                  const trimmed = p.trim();

                  if (/^[-–—]/.test(trimmed)) {
                    dashCounter++;
                    if (dashCounter % 2 === 1) {
                      return (
                        <p className="allnews__text" key={idx}>
                          <b>{trimmed}</b>
                        </p>
                      );
                    } else {
                      return (
                        <p className="allnews__text" key={idx}>
                          {trimmed}
                        </p>
                      );
                    }
                  }

                  return (
                    <p className="allnews__text" key={idx}>
                      {trimmed}
                    </p>
                  );
                })}
                {isExpanded && (
                  <p className="allnews__author">{article.author}</p>
                )}

                {/* 🔹 Проверка на PDF-файл */}
                {article.file && (
                  <div className="licenses__blank-link">
                    <p className="development__text">Материалы к новости:</p>
                    <a
                      href={article.file}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="structure__download-link licenses__link"
                    >
                      📄 Открыть PDF
                    </a>
                    <a
                      href={article.file}
                      download
                      className="structure__download-link licenses__link"
                    >
                      📥 Скачать PDF
                    </a>
                  </div>
                )}
              </div>

              <div className="allnews__blank-link">
                <button
                  onClick={() => toggleArticle(article.id)}
                  className="prevention__button news__button licenses__toggle-btn"
                >
                  {isExpanded ? "Скрыть" : "Подробнее"}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
